import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "w-100 d-flex justify-content-between my-3" }
const _hoisted_3 = { class: "w-100 d-flex justify-content-between" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "p-0 gx-3 card border-light" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "card-block" }
const _hoisted_11 = {
  class: "fz-6",
  style: {"height":"60px"}
}
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-globe" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-toggle-on" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "w-100 d-flex justify-content-between" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]

import { onMounted, ref } from "vue";
import { DialogHandler } from "./DialogHandler";
import { BlockFactory } from "../../blockly/BlockFactory";
// import { addImageSrcAttributeToWorkspace, addSkyBlockToWorkspace } from './uploader_common';
import axios from "axios";
import { ContentsUrl } from "../../utils/ContentsUrl";
import { MessageDialog } from "../../../framework/frontend/MessageDialog";
import { blocklyDispatcher } from "../../blockly/blocklyDispatcher";
import { blocklyStore } from "../../blockly/blocklyStore";
import { DialogHandlerCore } from "../../../framework/components/dialog/DialogHandlerCore";
import CoreDialog from "../../../framework/components/dialog/CoreDialog.vue";
import { translation } from "../../lang/Translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'Flicker360Dialog',
  setup(__props) {

const t = translation;
class FlikerPhoto {
  ateadded: string; // '1629648950';
  datetaken: string; //'2021-07-29 15:14:09';
  datetakengranularity: string; // '0';
  datetakenunknown: string; //'0';
  farm: number; // 66;
  height_c: number; // 400;
  height_h: number; //800;
  height_m: number; //250;
  id: string; // '51396019805';
  isfamily: number; //0;
  isfriend: number; //0;
  ispublic: number; //1;
  owner: string; // '76363614@N05';
  ownername: string; // 'auggie w';
  secret: string; // '7873ed79e0';
  server: string; // '65535';
  title: string; // 'Heading up Willisville Mountain, once again (interactive 360degree pano)';
  url_c: string; // 'https://live.staticflickr.com/65535/51396019805_7873ed79e0_c.jpg';
  url_h: string; // 'https://live.staticflickr.com/65535/51396019805_9640937703_h.jpg';
  url_m: string; // 'https://live.staticflickr.com/65535/51396019805_7873ed79e0.jpg';
  width_c: number; //800;
  width_h: number; //1600;
}

/**
 * 動的ラベル
 */
const dialogTitle = t.to("FlickrからVR背景画像を取得", "filckr_title");
const dialogId = DialogHandler.flickerDialogId;
// const skyBlockButtonTitle = t('uploader_view.btn_sky_block');
// const attSkyBlockButtonTitle = t('uploader_view.btn_att_sky_block');

// self.assets_dir = null;
const template_assets_dir = ref("");
const template_files = ref([] as FlikerPhoto[]);
const page = ref(1);
const keyword = ref("");
const lastPage = ref(1);

// 表示する
const list = async (pageNumber: number, keywordInput: string) => {
  let url = `https://api.flickr.com/services/rest`;
  url += `?api_key=5444dd0b2fea3b4110f4382466a45087`;
  url += `&method=flickr.groups.pools.getPhotos`;
  url += `&group_id=44671723@N00`;
  url += `&format=json&nojsoncallback=1`;
  url += `&extras=url_m,url_h,date_taken`; // url_c,url_h,
  if (keywordInput) {
    url += `&tags=${keywordInput}`;
  }
  url += `&page=${pageNumber}`;
  // console.log(url);
  const response: any = await axios.get(url);
  if (!response.data?.photos?.photo || response.data?.photos?.photo.length === 0) {
    MessageDialog.error(
      `データがありませんでした。キーワードを変えて実行してみてください`
    );
    return;
  }

  lastPage.value = response.data.photos.pages;
  // console.log(response.data.photos.photo[0]);
  template_files.value = response.data.photos.photo;
  const path = ContentsUrl.instance.contextPathByRun;
  template_assets_dir.value = path + response.data.dir;
};

const nextPage = async () => {
  page.value = page.value + 1;
  template_files.value = [];
  await list(page.value, keyword.value);
};
const prevPage = async () => {
  page.value = page.value - 1;
  template_files.value = [];
  await list(page.value, keyword.value);
};

const changeKeyword = async () => {
  template_files.value = [];
  page.value = 1;
  await list(page.value, keyword.value);
};

const closeDialog = () => {
  DialogHandlerCore.hideDialog(DialogHandler.flickerDialogId);
};

onMounted(() => {
  DialogHandler.onOpenDialog(dialogId, function () {
    list(page.value, keyword.value).then();
  });
});

const addskyImageBlockToWorkspace = (item: FlikerPhoto) => {
  const path = item.url_h;

  // ブロックを取得してワークスペースについか
  const factory = new BlockFactory();
  const sky = factory.getSkyBlock(path);
  factory.addWorkspace(sky);

  blocklyDispatcher.triggerMountedWorkspace(blocklyStore.workspace);
  DialogHandler.hideDialog(dialogId);
};

const addAttributeImageBlockToWorkspace = async (item) => {
  const path = item.url_h;

  // ブロックを取得してワークスペースについか
  const factory = new BlockFactory();
  const imageSrc = await factory.getImageSrcAttribute(path);
  factory.addWorkspace(imageSrc.toXml());

  blocklyDispatcher.triggerMountedWorkspace(blocklyStore.workspace);
  DialogHandler.hideDialog(dialogId);
};

return (_ctx: any,_cache: any) => {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createBlock(CoreDialog, {
    id: _unref(dialogId),
    "dialog-class": { 'modal-xl': true },
    title: _unref(dialogTitle)
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", {
          disabled: page.value === 1,
          class: "btn btn-primary",
          onClick: prevPage
        }, " << ", 8, _hoisted_20),
        _createElementVNode("button", {
          disabled: page.value === lastPage.value,
          class: "btn btn-primary",
          onClick: nextPage
        }, " >> ", 8, _hoisted_21)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, _toDisplayString(page.value) + " / " + _toDisplayString(lastPage.value), 1),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            id: "tags",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
            name: "tags",
            type: "text",
            class: "form-control me-3",
            placeholder: "タグ",
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, keyword.value]
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary w-25",
            onClick: changeKeyword
          }, "タグ指定")
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            disabled: page.value === 1,
            class: "btn btn-primary",
            onClick: prevPage
          }, " << ", 8, _hoisted_4),
          _createElementVNode("button", {
            disabled: page.value === lastPage.value,
            class: "btn btn-primary",
            onClick: nextPage
          }, " >> ", 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (template_files.value.length === 0)
          ? (_openBlock(), _createBlock(_component_loading, { key: 0 }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(template_files.value, (file) => {
          return (_openBlock(), _createElementBlock("div", {
            key: file.url_m,
            class: "col-xs-12 col-sm-6 col-md-4"
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("img", {
                src: file.url_m,
                class: "card-img-top w-100 img-responsive"
              }, null, 8, _hoisted_8),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, _toDisplayString(file.title), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-lg fz-6 me-3 w-50",
                    onClick: ($event: any) => (addskyImageBlockToWorkspace(file))
                  }, _hoisted_15, 8, _hoisted_13),
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-lg fz-6 w-50",
                    onClick: ($event: any) => (addAttributeImageBlockToWorkspace(file))
                  }, _hoisted_18, 8, _hoisted_16)
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["id", "title"]))
}
}

})